import React, { useState } from 'react';
import { Icons } from '../Icon.jsx';

const PropertySection = ({ title, children, defaultOpen = true, action, noPadding = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-admin_bordered">
      <div className="flex items-center bg-admin_canvas hover:bg-admin_neutral_1/10 transition-colors">
        <button 
          className="flex-1 flex items-center p-3 text-xs font-semibold text-admin_text_secondary uppercase tracking-wider text-left outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <Icons.ChevronDown className="mr-2 w-3.5 h-3.5" /> : <Icons.ChevronRight className="mr-2 w-3.5 h-3.5" />}
          {title}
        </button>
        {action && <div className="pr-3">{action}</div>}
      </div>
      {isOpen && <div className={`${noPadding ? '' : 'p-4'} bg-admin_paper relative`}>{children}</div>}
    </div>
  );
};

export default PropertySection;
